import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { FeeditemInterface } from 'app/models/feed.model';
import { FeeditemDataTransformGet } from './data-transforms/feeditem.data.transform.get';
import { FeeditemDataTransformPost } from './data-transforms/feeditem.data.transform.post';

@Injectable({
  providedIn: 'root',
})
export class FeeditemHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/feeditems(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformUp: FeeditemDataTransformGet,
    private readonly _transformDown: FeeditemDataTransformPost,
  ) {}

  intercept(req: HttpRequest<FeeditemInterface>, next: HttpHandler): Observable<HttpEvent<FeeditemInterface>> {
    return RequestService.getTransformedHttpEvent<FeeditemInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
